<template>
  <div v-if="productPanelInfo" class="product-panel-info">
    <div class="product-panel-info__attention">
      <svg width="20"
           height="20"
           viewBox="0 0 20 20"
           fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path d="M10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5229 0 20 4.47715 20 10C19.9939 15.5203 15.5203 19.9939 10 20ZM2 10.172C2.04732 14.5732 5.64111 18.1095 10.0425 18.086C14.444 18.0622 17.9995 14.4875 17.9995 10.086C17.9995 5.6845 14.444 2.10977 10.0425 2.086C5.64111 2.06246 2.04732 5.59876 2 10V10.172ZM12 15H9V11H8V9H11V13H12V15ZM11 7H9V5H11V7Z" fill="#FF2F00"/>
      </svg>
    </div>
    <div class="product-panel-info__title-wrap" v-html="productPanelInfo"></div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'ProductPanelInfo',
  computed: {
    ...mapState({
      productPanelInfo: state => state.productInfo.productInfo.productPanelInfo
    })
  }
}
</script>

<style scoped lang="sass">
.product-panel-info
  padding: 12px 15px
  border: 1px solid #E7E7E7
  border-radius: 3px
  display: flex
  align-items: flex-start
  flex-wrap: wrap
  margin-top: 10px
  +mmin($tablet)
    margin-top: 25px
  &__attention
    width: 20px
    height: 20px
    flex-shrink: 0
    margin-right: 12px
    margin-top: 2px
  &__title
    &-wrap
      color: #333333
      font-size: 16px
      line-height: 20px
      width: calc(100% - 32px)

      ::v-deep b
        font-weight: 500
        font-size: 16px
        line-height: 150%
        letter-spacing: 0

      ::v-deep a
        font-weight: 400
        font-size: 14px
        line-height: 100%
        letter-spacing: 0

        color: $nd-link-color
        text-decoration: underline
        text-decoration-style: dotted
</style>
